// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cdf_S","left":"styles_left__2gMDi"};